import IDomainBoundary from 'app/business-logic/domain-models/map/IDomainBoundary';
import { httpClient } from 'core/net/http';

// We are currently using the internal API to fetch the domain boundaries; once we have the ability to manage
// CALMET domains via the graph, we should use the graph to fetch this information instead.
export async function fetchDomainBoundaries(companyAlias: string, facilityAlias: string): Promise<IDomainBoundary[]> {
  const { data, isError, messages } = await httpClient.useInternalApi
    .withCredentials(companyAlias, facilityAlias)
    .get('facility/boundaries');
  if (isError) {
    throw new Error(messages?.join(', '));
  }
  return data as IDomainBoundary[];
}
